import React, { useRef } from 'react';
import {
  Button,
  CardLinkWithGAPromoClick,
  MediaCard,
  MediaCardContent,
  CardMedia,
  Section,
  SectionSubTitle,
  SwiperWithNavigation,
  SwiperSlide,
  Typography,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import {
  metalRoofOtherTypesCardMedia,
  metalRoofOtherTypesLink,
  metalRoofOtherTypesMediaCardContent,
  metalRoofOtherTypesMediaCardText,
  metalRoofOtherTypesSlide,
  metalRoofOtherTypesSwiper,
} from './metal-roof-other-types-styles';
import {
  METAL_ROOFT_OTHER_TYPES_LIST,
  MetalRoofOtherTypesStructure,
} from './metal-roof-other-types-constants';

type MetalRoofOtherTypesProps = {
  elementBlock: string;
  roofType: string;
  withSeamRoofing: boolean;
};

export const MetalRoofOtherTypes: React.FC<MetalRoofOtherTypesProps> = ({
  elementBlock,
  roofType,
  withSeamRoofing,
}) => {
  const cardRefs = useRef<HTMLAnchorElement[]>([]);

  const filterCondition = withSeamRoofing
    ? ({ key }: MetalRoofOtherTypesStructure) => key !== roofType
    : ({ key }: MetalRoofOtherTypesStructure) => key !== roofType && key !== 'falcevaya';

  const typesList = METAL_ROOFT_OTHER_TYPES_LIST.filter(filterCondition);

  const promotions = typesList.map(({ title }, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  return (
    <Section>
      <SectionSubTitle margin="m">Другие типы кровли</SectionSubTitle>
      <SwiperWithNavigation className={metalRoofOtherTypesSwiper} slidesPerView="auto" watchOverflow>
        {typesList.map(({ alt, imgSrc, link, title }, index) => (
          <SwiperSlide className={metalRoofOtherTypesSlide}>
            <CardLinkWithGAPromoClick
              bannerRefs={cardRefs}
              className={metalRoofOtherTypesLink}
              elementBlock={elementBlock}
              key={createElementKey('metalRoofOtherTypes', index)}
              {...link}
              position={index}
              promotion={promotions[index]}
              target="_blank">
              <MediaCard>
                <div className={metalRoofOtherTypesCardMedia}>
                  <CardMedia
                    className={metalRoofOtherTypesCardMedia}
                    alt={alt}
                    loading="lazy"
                    src={imgSrc}
                  />
                </div>
                <MediaCardContent className={metalRoofOtherTypesMediaCardContent}>
                  <Typography as="h3" className={metalRoofOtherTypesMediaCardText} variant="h3">
                    {title}
                  </Typography>
                  <div>
                    <Button variant="secondary">Подробнее</Button>
                  </div>
                </MediaCardContent>
              </MediaCard>
            </CardLinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </SwiperWithNavigation>
    </Section>
  );
};
